import { format, parseISO, } from 'date-fns'
import fr from 'date-fns/locale/fr'

export const formatIsoDate = (date, outputFormat='dd/MM/yy à HH:mm') => {
    return date ? format(parseISO(date), outputFormat, {locale: fr}) : null
}

export const formatDate = (date, outputFormat) => {
    return date ? format(date, outputFormat, {locale: fr}) : null
}

export const formatHour = hour => {
    if (!Boolean(hour)) return null
    let hoursMinutes = hour.split(':')
    hoursMinutes.pop()
    return hoursMinutes.join('h')
}

export const formatDueDate = date => {
    if (!Boolean(date)) return null
    const hours = formatIsoDate(date, 'HH:mm')
    if (hours === '00:00') {
        return formatIsoDate(date, 'dd/MM/yy')
    }
    return formatIsoDate(date)
}
